import React from "react";
import Footer from "../components/footer";
import AppNav from "../components/appNav";
import Hero from "../components/hero";
import OurFootprintSection from "../components/ourFootprintSection";
import { useTranslation } from "react-i18next";

const OurFootPrintPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>
      <main>
        <Hero
          title={t("Our Geographic Footprint")}
          text={t("Mapping success stories around the globe.")}
        />
        <OurFootprintSection />
        <Footer />
      </main>
    </div>
  );
};

export default OurFootPrintPage;
